import { createSlice } from '@reduxjs/toolkit';

import { experiments } from '../../experiments';
import { loadSolutions } from '../thunks/solutions.thunk';
import { ISolutionsState } from './types';

export const SEARCH_LIMIT = 60;
export const VESPA_SEARCH_RESULTS_LIMIT = 200;

const initialState: ISolutionsState = {
  query: '',
  solutions: null,
  error: null,
  isLoading: false,
  // Search can be also triggered by back button or history restoration
  isUserTypedSearch: false,
  paging: {
    hasMore: true,
  },
};

export const solutionsSlice = createSlice({
  name: 'solutions',
  initialState,
  reducers: {
    setIsUserTypedSearch: (state, action) => {
      state.isUserTypedSearch = action.payload;
    },
    resetSolutions: (state) => ({
      ...initialState,
      isUserTypedSearch: state.isUserTypedSearch,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(loadSolutions.pending, (state, action) => {
      return {
        ...state,
        query: action.meta.arg.query,
        error: null,
        isLoading: true,
      };
    });

    builder.addCase(loadSolutions.fulfilled, (state, action) => {
      const solutions = [...(state.solutions ?? []), ...action.payload];
      let hasMore =
        action.payload.length === SEARCH_LIMIT &&
        // https://app.asana.com/0/1200368299997249/1203307191704236
        solutions.length < VESPA_SEARCH_RESULTS_LIMIT;
      if (experiments.is('specs.helpwidget.newHomePage', 'true')) {
        hasMore = false;
      }
      return {
        ...state,
        solutions,
        error: null,
        isLoading: false,
        isUserTypedSearch: false,
        paging: { hasMore },
      };
    });

    builder.addCase(loadSolutions.rejected, (state, action) => {
      return {
        ...state,
        error: action.error as string,
        isLoading: false,
        isUserTypedSearch: false,
      };
    });
  },
});
